import { SURVEY_DATA_VIEWER_PATH } from './constants';

/**
 * True when this document load is a browser refresh and the URL is still on
 * the Survey Data Viewer path (so the panel would otherwise reopen).
 */
export function shouldCloseSurveyDataManagerAfterReload(
  pathname: string,
  surveyDataViewerPath: string,
  navigationType: string | null | undefined,
): boolean {
  if (navigationType !== 'reload') {
    return false;
  }
  return (
    pathname === surveyDataViewerPath ||
    pathname.startsWith(`${surveyDataViewerPath}/`)
  );
}

export function getDocumentNavigationType(): string | null {
  if (typeof performance === 'undefined') {
    return null;
  }
  if (typeof performance.getEntriesByType !== 'function') {
    return null;
  }
  const entries = performance.getEntriesByType('navigation');
  const entry = entries[0];
  if (entry && 'type' in entry && typeof entry.type === 'string') {
    return entry.type;
  }
  return null;
}

/**
 * If the page was refreshed while SDV was open, rewrite the URL to `/` before
 * React Router mounts so route, modal, and nav highlight stay in sync.
 */
export function dismissSurveyDataManagerPathAfterReload(
  surveyDataViewerPath: string = SURVEY_DATA_VIEWER_PATH,
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (
    !shouldCloseSurveyDataManagerAfterReload(
      window.location.pathname,
      surveyDataViewerPath,
      getDocumentNavigationType(),
    )
  ) {
    return false;
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.pathname = '/';
  window.history.replaceState(
    window.history.state,
    '',
    `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`,
  );
  return true;
}
